import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: null,
    isError: null,
    isActive: null,
    currentUser: null,
    messageErrorSearch: null,
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        fetchingUserStart: (state) => {
            state.isActive = true;
            state.isLoading = true;
            state.isError = false;
        },
        fetchingUserSuccess: (state, action) => {
            state.currentUser = action.payload;
            state.isLoading = false;
        },
        fetchingUserFailure: (state, action) => {
            state.isActive = false;
            state.isLoading = false;
            state.isError = true;
            state.messageErrorSearch = action.payload;
        },
        fetchingUserReset: (state) => {
            state.isActive = false;
            state.isLoading = false;
            state.currentUser = null;
            state.messageErrorSearch = null;
        },
    }
});

export const { fetchingUserFailure, fetchingUserStart, fetchingUserSuccess, fetchingUserReset } = userSlice.actions;

export default userSlice.reducer;